<template>
  <div class="home">

    <section id="main-home-banner">
      <div class="container-fuild">
        <div id="banner-row" class="row">
          <div class="home-text-div col-12 col-xl-6" style="background: #d6075b">
            <h1 class="banner-title">
                <strong>Rassembler les forces</strong> et les compétences au service des professionnels de la culture.<br> <br>
                <strong>Conjuguer les synergies</strong> pour imaginer les solutions adaptées à vos besoins.<br> <br>
                <strong>Vous offrir une prévention forte</strong>, cohérente et audacieuse. A travers le Pacte Prévention, l'AFDAS, Audiens et le CMB
                s'engagent désormais <strong>ensemble à vos côtés.</strong>
            </h1>
          </div>
          <div id="home-image-div" class="d-none d-xl-block col-xl-6" :style="{backgroundImage: 'url(' + require('@/assets/images/image_audas_home.jpg') + ')' }">
          </div>
        </div>
      </div>
    </section>



    <div class="container">

      <div class="row mt-4">
        <div class="col-12 text-center">
          <h1 class="main-title">
              Employeurs, salariés, branches professionnelles
          </h1>
          <h2 class="slogan mt-4">
            Face aux difficultés rencontrées notamment en contexte de crise, retrouvez ici vos accompagnements dédiés.
          </h2>
        </div>
      </div>


      <div class="row choice-button-div">
        <div class="col-12 col-lg-6">
          <b-button v-b-toggle.covid-accordion pill block variant="outline-primary" size="lg" class="mesures-button">Mesures spéciales Covid</b-button>
        </div>
        <div class="col-12 order-lg-3 order-2">
          <b-collapse id="covid-accordion" accordion="aides-accordion" role="tabpanel">
            <div class="row mt-3">
              <div class="col-lg-4">
                <b-button pill block variant="outline-dark" size="lg" @click="goToEmployeursCovid">Employeurs</b-button>
              </div>
              <div class="col-lg-4 mt-2 mt-lg-0">
                <b-button v-b-toggle.collapse-covid-types pill block variant="outline-dark" size="lg">Salariés</b-button>
                <b-collapse id="collapse-covid-types">
                  <div class="row mt-2">
                    <div class="col-12">
                      <b-button pill block variant="outline-dark" @click="goToSalariesCovid('PERM')">Permanents</b-button>
                      <b-button pill block variant="outline-dark" @click="goToSalariesCovid('INTER')">Intermittents</b-button>
                      <b-button pill block variant="outline-dark" @click="goToSalariesCovid('PIG')">Journalistes pigistes</b-button>
                    </div>
                  </div>
                </b-collapse>

              </div>
              <div class="col-lg-4 mt-2 mt-lg-0">
                <b-button pill block variant="outline-dark" size="lg" @click="goToBranchesProCovid">Branches professionnelles</b-button>
              </div>
            </div>
          </b-collapse>
        </div>

        <div class="col-12 col-lg-6 order-lg-2 order-3 mt-3 mt-lg-0">
          <b-button v-b-toggle.other-accordion pill block variant="outline-primary" size="lg" class="mesures-button">Autres services partagés</b-button>
        </div>

        <div class="col-12 order-4">
          <b-collapse id="other-accordion" accordion="aides-accordion" role="tabpanel">
            <div class="row mt-3">
              <div class="col-lg-6">
                <b-button pill block variant="outline-dark" size="lg" @click="goToOtherEmployeurs">Employeurs</b-button>
              </div>
              <div class="col-lg-6 mt-2 mt-lg-0">
                <b-button v-b-toggle.collapse-other-types pill block variant="outline-dark" size="lg">Salariés</b-button>
                <b-collapse id="collapse-other-types">
                  <div class="row mt-2">
                    <div class="col-12">
                      <b-button pill block variant="outline-dark" @click="goToOtherSalaries('PERM')">Permanents</b-button>
                      <b-button pill block variant="outline-dark" @click="goToOtherSalaries('INTER')">Intermittents</b-button>
                      <b-button pill block variant="outline-dark" @click="goToOtherSalaries('PIG')">Journalistes pigistes</b-button>
                    </div>
                  </div>
                </b-collapse>
              </div>
              <!--<div class="col-lg-4 mt-2 mt-lg-0">
                <b-button pill block variant="outline-dark" size="lg" @click="goToBranchesPro">Branches professionnelles</b-button>
              </div>-->
            </div>
          </b-collapse>
        </div>
      </div>


      <div class="row" style="margin-top: 100px; margin-bottom: 75px;">
        <div class="col-12 text-center">
            <img src="@/assets/images/initiative_img.png"
                      alt="Audiens" style="width: 100%; max-width: 700px;">
        </div>
      </div>




    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  computed: {
    typeSalarie: {
      get () {
        return this.$store.state.characteristics.typeSalarie
      },
      set (value) {
        this.$store.commit('characteristics/set', ['typeSalarie', value])
      }
    },
  },
  methods: {
    goToEmployeursCovid () {
       this.$router.push('/covid/employeurs')
    },
    goToSalariesCovid (type) {
      this.typeSalarie = type
      this.$router.push('/covid/salaries')
    },

    goToOtherEmployeurs () {
       this.$router.push('/autre/employeurs')
    },
    goToOtherSalaries (type) {
      this.typeSalarie = type
      this.$router.push('/autre/salaries')
    },

    goToBranchesProCovid () {
       this.$router.push('/covid/branches-professionnelles')
    },


  }
}
</script>

<style>


#home-image-div {
  background-size: cover;
  background-position:center;
}

#banner-row {
  height: 400px;
  line-height: 400px;

}

.home-text-div {
  padding-left: 50px;
  padding-right: 50px;
}
.banner-title {
  color: white;
  font-size: 18px;
  display: inline-block;
  vertical-align: middle;
}

.main-title {
  font-size: 20px;
  font-weight: bold;
  font-style: italic;
  text-transform: uppercase;
}

.slogan {
  font-size: 16px;
  font-weight: 400;
}

.choice-button-div{
  margin-top: 20px;
}

.divider-home-button-logo {
  margin-top: 30px;
}

.mesures-button {
  text-transform: uppercase;
}


.section-title {
  font-weight: bold;
  font-size: 20px;
  color: #d6075b;
}


@media (min-width: 480px) {
  .banner-title {
    font-size: 20px;
  }
  .main-title {
    font-size: 20px;
  }

  .slogan {
    font-size: 20px;
  }

}


@media (min-width: 768px) {
  .banner-title {
    font-size: 24px;
  }

  .choice-button-div{
    margin-top: 40px;
  }

  .mesures-button {
    padding: 1rem 1.5rem;
    font-size: 1.75rem;
    line-height: 1.5;
  }

  .divider-home-button-logo {
    margin-top: 50px;
  }


  .section-title {
    font-size: 22px;
  }

}

@media (min-width: 1024px) {
  .banner-title {
    font-size: 24px !important;
  }

  .main-title {
    font-size: 32px;
  }

  .slogan {
    font-size: 26px;
  }

}

</style>
